// Turns the raw Graph /users list into the people the turnover pickers offer
// (Project Manager, Assigned To, action items). Graph's /users also returns
// rooms, shared mailboxes, meeting / resource accounts, guests and disabled
// accounts — none of them somebody a task can be assigned to. Pure.
//
// Which fields come back depends on the token: User.ReadBasic.All returns
// displayName / givenName / surname / mail only, the rest arrive as null. So
// every check below applies only when its field was actually returned — a
// missing field never removes a real person.

export const DIRECTORY_SELECT = "displayName,givenName,surname,mail,department,userType,accountEnabled,assignedLicenses";

const text = (v) => (typeof v === "string" ? v.trim() : "");

// A real, current, internal person: a first AND last name, an enabled account,
// a member (not a guest) and — when licenses were readable — at least one
// license (rooms and shared mailboxes carry none).
export function isRealPerson(u) {
  if (!u || !text(u.displayName) || !text(u.mail)) return false;
  if (!text(u.givenName) || !text(u.surname)) return false;
  if (u.accountEnabled === false) return false;
  if (text(u.userType).toLowerCase() === "guest") return false;
  if (Array.isArray(u.assignedLicenses) && u.assignedLicenses.length === 0) return false;
  return true;
}

// → [{ label, email, department }] sorted by name, one row per mailbox.
export function toDirectoryUsers(rawUsers) {
  const seen = new Set();
  const out = [];
  for (const u of rawUsers || []) {
    if (!isRealPerson(u)) continue;
    const email = text(u.mail);
    const key = email.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    out.push({ label: text(u.displayName), email, department: text(u.department) });
  }
  return out.sort((a, b) => a.label.localeCompare(b.label));
}
